<template>
    <div class="filterBox">
        <el-dialog v-dialog-drag title="云铺销售员列表设置" :visible.sync="dialogVisible" width="500px" class="eldialog eldialogFilter" :model="false">
            <div class="dragTable">
                <div :class="['dragThead', isScroll ? 'thGlutter' : '', 'clearfix']">
                <div class="th first">序号</div>
                <div class="th">姓名</div>
                <div class="th">联系电话</div>
                <div class="th">排序(可拖动)</div>
                <div class="th">是否显示</div>
                </div>
                <div class="dragTbody" id="dragTbody" ref="dragTbody">
                <div
                    class="dragTbodyTr clearfix"
                    @dragstart="dragstart($event, item, index)"
                    @dragend="dragend($event, item, index)"
                    @dragenter="dragenter($event, item, index)"
                    @dragleave="dragleave($event)"
                    @dragover="dragover($event)"
                    @drop="dragdrop($event)"
                    :draggable="true"
                    v-for="(item, index) in list"
                    :key="'drag' + index"
                >
                    <div class="td first">{{ index + 1 }}</div>
                    <div class="td">{{ item.name }}</div>
                    <div class="td">{{ item.mobile }}</div>
                    <div class="td">
                    <div class="clearfix sort">
                        <div class="sortBack"></div>
                    </div>
                    </div>
                    <div class="td last">
                    <el-switch
                        v-model="item.show"
                        active-color="#B21111"
                        :active-value="1"
                        inactive-color="#ccc"
                        :inactive-value="false"
                        @change="changeStatus(item, $event)"
                    >
                    </el-switch>
                    </div>
                </div>
                </div>
            </div>
            <span style="text-align: left;font-size: 12px;color: #a6a6a6;"><span style="color: red;font-size: 14px;">注释：</span>Boss可以自定义设置销售员显示或排序</span>
            <div class="filterBtnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="save">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import bus from "../../../eventBus";
    export default {
        props:["tableData","filterDialogVisible","scene","isGlobal"],
        data(){
            return{
                list:this.tableData,
                dialogVisible:this.filterDialogVisible,
                sceneC:this.scene,
                moveRow: {},
                isScroll: false,
                originalList:[]
            }
        },
        mounted() {
            let emit = ("changeHeadWidth" + this.sceneC).replace(/\./g, "");
            bus.$off(emit).$on(emit, (res) => {
            let list = JSON.parse(JSON.stringify(this.list));
            list.forEach((item) => {
                if (item.field == res.name) {
                item.width = res.width;
                }
            });
            this.list = list;
            this.save(false);
            });
            let emitSort = ("changeHeadSort" + this.sceneC).replace(/\./g, "");
            bus.$off(emitSort).$on(emitSort, (res) => {
            let list = [];
            res.forEach((item) => {
                this.list.forEach((child) => {
                if (item.colKey == child.id) {
                    list.push(JSON.parse(JSON.stringify(child)));
                }
                });
            });
            for (let i = 0; i < list.length; i++) {
                list[i].sort = i + 1;
            }
            this.list = list;
            this.save(false);
            });
        },
        beforeDestroy() {
            let emit = ("changeHeadWidth" + this.sceneC).replace(/\./g, "");
            let emitSort = ("changeHeadSort" + this.sceneC).replace(/\./g, "");
            bus.$off(emit);
            bus.$off(emitSort);
        },
        methods:{
            hasScrollbar() {
                let height = this.list.length * 31;
                return height > 510;
            },
            togDragClass(enter=false) {
                let c = "dragTbodyTr clearfix";
                if (enter ===true) {
                    c = "dragTbodyTr clearfix dragHover";
                }
                return c;
            },
            dragenter(e, row, indexNumber) {
                e.currentTarget.classList = this.togDragClass(true);
                let list = JSON.parse(JSON.stringify(this.list));
                if (indexNumber < list.length - 1) {
                    list.forEach((item, index) => {
                    if (item.isMove) {
                        list.splice(index, 1);
                    }
                });
                list.splice(indexNumber, 0, this.moveRow);
                }
                this.list = list;
                e.preventDefault();
            },
            dragend(e, row) {
                if (this.originalList.length == this.list.length) {
                    let list = JSON.parse(JSON.stringify(this.list));
                    list.forEach((item, index) => {
                    if (this.moveRow.id == item.id) {
                        if (!item.isMove) {
                        list.splice(index, 1);
                        } else {
                        item.isMove = false;
                        }
                    }
                    });
                    for (let i = 0; i < list.length; i++) {
                    list[i].sort = i + 1;
                    }
                    this.list = list;
                } else {
                    this.list = JSON.parse(JSON.stringify(this.originalList));
                }
                this.moveRow = {};
            },
            dragstart(e, row) {
                row.isMove = true;
                this.moveRow = JSON.parse(JSON.stringify(row));
            },
            dragover(e) {
                e.preventDefault();
            },
            dragdrop(e) {
                e.currentTarget.classList = this.togDragClass(false);
            },
            dragleave(e) {
                e.currentTarget.classList = this.togDragClass(false);
            },
            save(){
                let url = "";
                url = "erp/cloud.store.user.update";
                let arrnew = this.list.map((item,index) => {
                    item.show==false?item.show=0:item.show=1;
                    return Object.assign({},{'id':item.id,'sort':item.sort,'show':item.show})
                })
                this.postFuncLoading(url,{column:arrnew},()=>{
                    this.tip("修改成功","success")
                    this.dialogVisible = false;
                    this.$emit("confirm")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            changeIndex(row, direction, index) {
                let list = JSON.parse(JSON.stringify(this.list));
                if (direction == "down") {
                    if (index < list.length - 2) {
                    var item = JSON.parse(JSON.stringify(list[index]));
                    list[index] = list[index + 1];
                    list[index + 1] = item;
                    }
                } else if (direction == "up") {
                    if (index > 0) {
                    var item = JSON.parse(JSON.stringify(list[index]));
                    list[index] = list[index - 1];
                    list[index - 1] = item;
                    }
                }
                for (let i = 0; i < list.length; i++) {
                    list[i].sort = i + 1;
                }
                this.list = list;
            },
            changeStatus(row,val){
                this.list.forEach((item,index)=>{
                    if(item.id==row.id){
                        this.list[index].show = val;
                    }
                })
                //this.$emit("confirm",this.list)
            },
        },
        watch:{
            filterDialogVisible: function (val) {
                this.dialogVisible = val;
                if (val) {
                    this.$nextTick((res) => {
                    this.isScroll = this.hasScrollbar();
                    });
                }
            },
            tableData: function (val) {
                this.list = val;
                this.originalList = JSON.parse(JSON.stringify(val));
            },
            dialogVisible: function (val) {
                if (!val) {
                    this.$emit("dialogChangeFunc", val);
                }
            },
            scene: function (val) {
                this.sceneC = val;
            },
        }
    }
</script>
<style scoped>
.dragTable {
  width: 100%;
  position: relative;
  padding-top: 30px;
  height: 100%;
  box-sizing: border-box;
  flex: 1;
  overflow: hidden;
}

.dragTable >>> .dragHover {
  background-color: #b1d2a8 !important;
}
.dragThead {
  width: 100%;
  height: 30px;
  position: absolute;
  top: 0;
  left: 0;
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
  box-sizing: border-box;
}
.dragTbody {
  height: 100%;
  overflow: auto;
}
.dragThead .th {
  width: 21.3%;
  float: left;
  line-height: 30px;
  background-color: #ebe8e8;
  color: #000;
  font-size: 12px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-top: 0;
  border-left: 0;
  text-align: center;
}
.dragTbody .td {
  width: 21.3%;
  float: left;
  font-size: 12px;
  line-height: 30px;
  min-height: 30px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-top: 0;
  border-right: 0;
  text-align: center;
}
.dragThead .th.first {
  width: 12%;
}
.dragTbody .td.first {
  width: 12%;
}
.dragTbody .td.last{
  border-right: 1px solid #ccc;
}
.dragTbody .sort {
  height: 30px;
  text-align: center;
  padding: 0 15px;
}
.sortBack{
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin: auto;
  background: url(/icon/drag_dark.png) no-repeat content-box center ;
  background-size: contain;
  position: relative;
  top: 6px;
}
.sortBack:hover{
  background-image: url(/icon/drag_light.png);
}
.thGlutter {
  padding-right: 8px;
}

.replace-enter,
.replace-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.replace-enter-active,
.replace-leave-active {
  transition: all 1s ease;
}
</style>